import { delTunnel } from "../../constants/tunnels";

export default function DeleteModal({ cancelDelete, confirmDelete }) {
  return (
    <delTunnel.In>
      <div
        style={{
          width: "80vw",
          maxWidth: "500px",
          transform: "translate(-50%, -50%)",
          zIndex: 10000000,
          top: "50%",
          left: "50%",
          position: "absolute",
          background: "white",
          border: "3px solid #000000",
          padding: "20px 30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
          fontFamily: "DM Mono, monospace",
          fontSize: "30px",
        }}
      >
        <p>Delete Decoration?</p>
        <div
          style={{
            marginTop: "15px",
            fontSize: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <button
            onClick={confirmDelete}
            style={{
              marginRight: "10px",
              padding: "6px 12px",
              backgroundColor: "#26EF96",
              color: "black",
              border: "none",
              cursor: "pointer",
              width: "40%",
              minWidth: "fit-content",
            }}
          >
            Yes
          </button>
          <button
            onClick={cancelDelete}
            style={{
              border: "3px solid #000000",
              padding: "6px 12px",
              cursor: "pointer",
              width: "40%",
              minWidth: "fit-content",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </delTunnel.In>
  );
}
